import { escapeXmlEntities } from "@nova/util-strings"
import { Point } from "./data-create-hotspots-kml"
import { PlacemarkBuilder } from "./hotspotsToKML"

const TAKPlacemarkBuilder = (options: TAKHotspotOptions): PlacemarkBuilder => ({
    build: (id, point) => createTAKPlacemark(id, point),
    buildStyle: () => `
    <Style id="redCircle">
        <IconStyle>
            <color>ff0000ff</color>
            <scale>1.1</scale>
        </IconStyle>
        ${
            options.disableLabels
                ? `
        <LabelStyle>
            <scale>0</scale>
        </LabelStyle>`
                : ""
        }
    </Style>`,
})

interface TAKHotspotOptions {
    disableLabels?: boolean
}

const createTAKPlacemark = (id: string, { label, latitude, longitude }: Point) => {
    return `
        <Placemark id="placemark-${id}">
            <styleUrl>#redCircle</styleUrl>
            <name>${escapeXmlEntities(label)}</name>
            <Point id="point-${escapeXmlEntities(label)}">
                <coordinates>${longitude},${latitude},0.0</coordinates>
            </Point>
        </Placemark>`
}

export { TAKPlacemarkBuilder }
export type { TAKHotspotOptions }
